module.exports = __webpack_public_path__ + "img/乐享官网banner1.bea2bb22.jpg";